export default "__VITE_ASSET__vDmhjS2U__"